import {AfterViewInit, Component, OnInit } from '@angular/core';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewInit  {

  numeroWhatsapp: string = "";
  mensajeWhatsapp: string = "";
  flagPCI: string = "NO";

  constructor(
    private secureStorageService: SecureStorageService
  ){}

  ngOnInit(): void {

  }

  ngAfterViewInit(){
    const data = JSON.parse(this.secureStorageService.getData('designConfig') || "false");
    const logoElements = document.querySelectorAll('.logo-horizontal-secundario');
    if(data){

      this.numeroWhatsapp = data.NUMERO_TELEFONO_WHATSAPP;
      this.mensajeWhatsapp = data.MENSAJE_PREDETERMINADO_WHATSAPP;
      this.flagPCI = data.MOSTRAR_LOGO_PCI;

      if (logoElements) {
        logoElements.forEach(logoElement => {
          logoElement.setAttribute('src', data.LOGO_HORIZONTAL_SECUNDARIO);
        });
      }
    }

  }

  mostrarPCI(){
    if(this.flagPCI === "SI"){
      return true;
    }
    return false
  }

  sendMessage() {
    const phoneNumber = this.numeroWhatsapp;
    const message = encodeURIComponent(this.mensajeWhatsapp);
    let baseUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

    window.open(baseUrl, '_blank');
  }

}
